import React, { useState, useEffect, useRef } from "react";
import Typography from "./Typography";
import { borderRadius, spacing } from "../utils/tokens";
import { useTheme } from "../context/ThemeContext";

import { Headphones, BookmarkSimple } from "@phosphor-icons/react";
import Divider from "./Divider";

function TickerNews({
    item
}){
    const { theme } = useTheme();


    function truncateText(text, maxLength) {
        return text.length > maxLength ? text.slice(0, maxLength) + "..." : text;
    }

    const styles = {
              cardContainer:{
                display: "flex",
                flexDirection: "column",
                gap: spacing.xxxs,
                width: "100%",
                height: "fit-content",
                backgroundColor: theme.colors.fillPrimary,
                color: theme.colors.contentPrimary,
                padding: spacing.xxxs,
                boxSizing: "border-box",
              },
              card: {
                display: "flex",
                flexDirection: "column",
                gap: spacing.m,
                padding: spacing.m,
              },
              cardContent: {
                display: "flex",
                gap: spacing.m,
                width: "100%",
                height: "fit-content",
                backgroundColor: theme.colors.fillPrimary,
                color: theme.colors.contentPrimary,
                boxSizing: "border-box",
              },
              textGroup: {
                display: "flex",
                flexDirection: "column",
                gap: spacing.s,
              },
              actionsContainer: {
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                gap: spacing.s,
              },
              iconsContainer:{
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-end",
                gap: spacing.m,
              }
          };


    return (
        <div style={styles.cardContainer}>
            <div style={styles.card}>
                <div style={styles.cardContent}>
                    <div style={styles.textGroup}>
                        <Typography variant="label" type="utility" style={{ color: theme.colors.contentSecondary }}>DEFAULT</Typography>
                        <Typography variant="headlineS" type="editorial" style={{ color: theme.colors.contentPrimary }}>
                            {truncateText(item.title, 80)}
                        </Typography>
                    </div>
                    <img src={item.image_url || item.urlToImage} alt={item.title} style={{ width: "72px", height: "72px", objectFit: "cover" }} />
                </div>
                <div style={styles.actionsContainer}>
                    <Typography variant="supportingCaption" type="editorial" style={{ color: theme.colors.contentSecondary, width: "100%" }}>
                        6 min read
                    </Typography>
                    <div style={styles.iconsContainer}>
                        <Headphones size={24} color={theme.colors.contentSecondary} />
                        <BookmarkSimple size={24} color={theme.colors.contentSecondary} />
                    </div>
                </div>
            </div>
            <Divider />
        </div>
    )
}

export default TickerNews;